/** Ordering metadata never supplies a confirmed place or prize. */
interface OrderedRankingRow { standing_index?: number | null; is_self: boolean }
export type RankingLeaderboardItem<Row> = { type: 'row'; row: Row } | { type: 'gap' };
export const RANKING_PARTICIPANT_TOP_LIMIT = 20;

function ordinal(row: OrderedRankingRow): number | null {
  return Number.isSafeInteger(row.standing_index) && row.standing_index! > 0 ? row.standing_index! : null;
}

export function buildRankingLeaderboardItems<Row extends OrderedRankingRow>({ topRows, nearbyRows = [], myRow }: {
  topRows: Row[]; nearbyRows?: Row[]; myRow?: Row | null;
}): RankingLeaderboardItem<Row>[] {
  const seen = new Set<number>();
  let hasSelf = false;
  const distinct = (row: Row) => {
    const index = ordinal(row);
    if ((index != null && seen.has(index)) || (row.is_self && hasSelf)) return false;
    if (index != null) seen.add(index);
    if (row.is_self) hasSelf = true;
    return true;
  };
  const top = topRows.slice(0, RANKING_PARTICIPANT_TOP_LIMIT).filter(distinct);
  const items: RankingLeaderboardItem<Row>[] = top.map(row => ({ type: 'row', row }));
  if (hasSelf || !myRow) return items;

  const ownIndex = ordinal(myRow);
  const nearby = ownIndex == null ? [] : nearbyRows.filter(row => {
    const index = ordinal(row);
    return index != null && Math.abs(index - ownIndex) <= 3;
  });
  if (!nearby.some(row => row.is_self)) nearby.push(myRow);
  nearby.sort((a, b) => (ordinal(a) ?? Infinity) - (ordinal(b) ?? Infinity));
  let previousIndex = top.length ? ordinal(top[top.length - 1]) : null;
  for (const row of nearby.filter(distinct)) {
    const index = ordinal(row);
    if (previousIndex != null && index != null && index > previousIndex + 1) items.push({ type: 'gap' });
    items.push({ type: 'row', row });
    previousIndex = index;
  }
  return items;
}
